<script>
import { defineComponent, ref, watch } from "@vue/composition-api";
import EzTable from "../../ultils/Table/EzTable.vue";
import ModalAccount from "../../ListArClient/ModalAccount/ModalAccount.vue";
import AccountTransaction from "./AccountTransaction.vue";
import { arClient } from "@/api/ar-client";
import { Fragment } from "vue-fragment";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";
import { AR_HSAA01, AR_RAA02, AR_IAA01 } from "@/api/constant";
import PermissionButton from "../../ultils/Button/PermissionButton.vue";

export default defineComponent({
  name: "TableAccount",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
    columns: {
      type: Array,
      default: [],
    },
  },
  components: {
    AccountTransaction,
    ModalAccount,
    Fragment,
    EzTable,
    PermissionButton,
  },
  setup() {
    const isShow = ref(false);
    const accountId = ref(null);
    const isAccountSurplusHistoryVisible = ref(false);

    const accountCode = ref("");

    const tableRef = ref();
    const actions = ref([
      {
        apiCode: AR_RAA02,
        title: "ar_common_detail",
        icon: "eye",
      },
      {
        apiCode: AR_HSAA01,
        title: "ar_client_surplus_history",
        icon: "bar-chart",
      },
      /*  {
        danger: true,
        icon: "trash",
        title: "ar_common_delete",
      }, */
    ]);
    const onAfterUpdateAccount = () => {
      tableRef.value.fetchData();
      isShow.value = false;
    };

    const { fetchData: deleteAccount } = useFetch(arClient.api_AR_DAA01, {
      nextFunction: () => {
        onAfterUpdateAccount();
      },
    });
    return {
      AR_IAA01,
      accountCode,
      isAccountSurplusHistoryVisible,
      actions,
      isShow,
      accountId,
      tableRef,
      onAfterUpdateAccount,
      deleteAccount,
    };
  },
  computed: {
    ArTravelAgentId() {
      return this.data.Id || this.$route.params.id;
    },
  },
});
</script>
<template>
  <div>
    <AccountTransaction
      :id="accountId"
      :is-show.sync="isAccountSurplusHistoryVisible"
      :account-code="accountCode"
    />

    <ModalAccount
      v-if="isShow"
      @refetch="onAfterUpdateAccount"
      :accountId="accountId"
      :isShow.sync="isShow"
      :travelAgentId="ArTravelAgentId"
    />
    <EzTable
      ref="tableRef"
      @action-1="
        (data) => {
          isShow = true;
          accountId = data.data.Id;
        }
      "
      @action-2="
        (data) => {
          isAccountSurplusHistoryVisible = true;
          accountId = data.data.Id;
          accountCode = data.data.AccountCode;
        }
      "
      :actions="actions"
      :toolbarConfig="{ disableColumnChooser: this.data.Id }"
      :pageConfig="{ disablePagination: this.data.Id }"
      :data-source="arClient.api_AR_RAA01"
      :columns="columns"
      :data-source-params="{ ArTravelAgentId }"
    >
      <template #beforeToolbarActions>
        <slot name="beforeToolbarButton"> </slot>
      </template>
      <template #toolbar>
        <div>
          <slot name="button"> </slot>
          <PermissionButton
            :api-code="AR_IAA01"
            style="margin-left: 6px"
            @click="
              () => {
                isShow = true;
                accountId = null;
              }
            "
            variant="outline-primary"
          >
            <ez-icon icon="ezAr-icon-plus-circle" />
            {{ $t("ar_common_add_new") }}
          </PermissionButton>
        </div>
      </template>
    </EzTable>
  </div>
</template>
